import React from 'react';
import classNames from 'classnames';
import { LineItem } from '../../hooks/useCart/cart.rest';
import { LineItemMini, LineItemMiniGranularity } from '../LineItem';
import { hasError } from './hasError';
import './LineItemListMini.scss';

type Props = {
  granularity?: LineItemMiniGranularity;
  theme?: 'box' | 'simple';
  title?: string;
  items: LineItem[];
  showPriceWithVAT?: boolean;
  readOnly?: boolean;
};

export const LineItemListMini: React.FC<Props> = ({
  granularity = LineItemMiniGranularity.Full,
  theme = 'box',
  title,
  items,
  showPriceWithVAT,
  readOnly
}) => (
  <div
    className={classNames(
      'LineItemListMini',
      `LineItemListMini--${granularity}`,
      `LineItemListMini--${theme}`,
      {
        'LineItemListMini--error': hasError(items)
      }
    )}
  >
    {title && <h2 className="LineItemListMini__title">{title}</h2>}
    {items.map(item => (
      <div key={item.id} className="LineItemListMini__item">
        <LineItemMini
          showPriceWithVAT={showPriceWithVAT}
          granularity={granularity}
          item={item}
          readOnly={readOnly}
        />
      </div>
    ))}
  </div>
);
